import React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem, Autocomplete, FormHelperText, TextField, Box, useTheme, Stack } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import { blue } from "@mui/material/colors";
import { tr } from "date-fns/esm/locale";

const useStyles = makeStyles((theme) => ({
    customLabel: {
        fontSize: "13px", // Adjust the font size as needed
        paddingTop: 1,
    },
    resize: {
        fontSize: 13,
    },
    root: {
        "& .MuiFormControl-root": {
            margin: 0,
        },
    },
    select: {
        "&:before": {
            borderColor: blue,
        },
        "&:after": {
            borderColor: "#008000",
        },
    },
}));

const Footer = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const theme = useTheme();
    return (
        <Box
            sx={{
                width: "100%",
                px: 1,
                py: 1,
                m: 1,
                mt: 0,
                alignItems: "center",
                backgroundColor: theme.palette.grey[100],
                borderRadius: "12px",
                boxShadow: 3
            }}
        >
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" flexWrap="wrap">
                <Box sx={{ minWidth: 250, flexGrow: 1 }}>
                    <Autocomplete
                        className={classes.root}
                        onChange={(event, newValue) => {
                            props.handleExecutedTechnicianChange(newValue);
                        }}
                        size={"small"}
                        options={props.techData}
                        sx={{ width: 300 }}
                        disabled={props.disableStates.isExecutedDisable}
                        value={props.executedTechnicianName}
                        renderInput={(params) => (
                            <TextField {...params} margin="normal" error={props.hasExecutedError} helperText={props.executedErrorText} label={t("AnalysisExecutedBy")} variant="outlined" />
                        )}
                        renderOption={(_props, option) => <li {..._props}>{option.userName}</li>}
                    />
                </Box>
                <Box sx={{ minWidth: 250, flexGrow: 1 }}>
                    <Autocomplete
                        className={classes.root}
                        onChange={(event, newValue) => {
                            props.handleVerifiedTechnicianChange(newValue);
                        }}
                        size={"small"}
                        options={props.techData}
                        sx={{ width: 300 }}
                        disabled={props.disableStates.isVerifiedDisable}
                        value={props.verifiedTechnicianName}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                margin="normal"
                                error={props.hasVerifiedError}
                                helperText={props.verifiedErrorText}
                                label={t("VerifiedBy")}
                                variant="outlined"
                                id="ewo_maintenance_operators"
                            />
                        )}
                        renderOption={(_props, option) => <li {..._props}>{option.userName}</li>}
                    />
                </Box>
                <Box sx={{ minWidth: 160 }}>
                    <FormControl fullWidth disabled={props.disableStates.isSignatureDisable}>
                        <InputLabel id="demo-simple-select-label">Signature</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            error={props.hasSignatureError}
                            value={props.signature}
                            label={t("Signature")}
                            onChange={props.handleSignatureChanged}
                            size="small"
                        >
                            <MenuItem value={true}>OK</MenuItem>
                            <MenuItem value={false}>NOK</MenuItem>
                        </Select>
                        <FormHelperText error={props.hasSignatureError}>{props.signatureErrorText}</FormHelperText>
                    </FormControl>
                </Box>
                <Box sx={{ minWidth: 180 }}>
                    <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                        <DatePicker
                            id="bl_table_DatePicker _13"
                            renderInput={(_props) => <TextField {..._props} size="small" error={props.hasClosureDateError} helperText={props.closureDateErrorText} />}
                            inputFormat="dd.MM.yyyy"
                            disabled={props.disableStates.isClosureDateDisable}
                            value={props.closureDate}
                            label={t("ClosureDate")}
                            onChange={props.handleClosureDateChange}
                            ampm={false}
                            minDate={new Date()}
                        />
                    </LocalizationProvider>
                </Box>
            </Stack>
        </Box>
    );
};

export default Footer;
